import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem, Typography } from "@mui/material";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import Sidebar from "~src/layouts/sidebar/Sidebar";
import callAPI from "~src/utils/callAPI";
import { NAVBAR_BLUE, WHITE } from "~src/data/constant";
import convertToTitleCase from "~src/utils/convertToTitleCase";
import logo from '../../assets/images/analyticsWhite.svg';

const drawerWidth = 240;
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Navbar({
  open,
  setOpen,
  shouldDashboardsReload,
  setShouldDashboardsReload,
  heading,
  hideSidebar // If true, the sidebar will not be rendered
}) {
  
  const history = useHistory();

  const username = localStorage.getItem("user") || "";

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleMouseLeave = (event) => {
    setAnchorEl(null);
  };
  const handleMenuClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      const target = event.currentTarget;
      setAnchorEl(target);
    }
  };
  const handleClose = () => {
    callAPI("GET", "logout/", "")
      .then(() => {
        localStorage.clear();

        /* change expire attribute of cookies to current time, so it expires. 
        Note this doesn't work for http only cookies, so only csrf cookie will expire. sessionid is handled by django itself */
        document.cookie.split(";").forEach((cookie) => {
          document.cookie = cookie
            .replace(/^ +/, "")
            .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });
      })
      .then(() => {
        history.push("/login");
      });
  };

  return (
    <>
      {/* <CssBaseline /> */}
      {/* <AppBar
        position="fixed"
        open={open}
        style={{
          backgroundColor: NAVBAR_BLUE,
        }}
      >
        <Toolbar
          variant="dense"
          className="flex flex-row items-center justify-between p-0"
        >
          <img src={logo} alt="" width="25" height="25" className="ml-2" />
        
       
            <div className="ml-14 flex-grow">
              <Typography variant="h5">{heading}</Typography>
            </div>
          

          <div className="flex items-center">
            <div style={{ width: "9rem" }}>{convertToTitleCase(username)}</div>
          </div>
        </Toolbar>
      </AppBar> */}
      {!hideSidebar && (
        <Sidebar
          open={open}
          setOpen={setOpen}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleDrawerOpen}
          shouldDashboardsReload={shouldDashboardsReload}
          setShouldDashboardsReload={setShouldDashboardsReload}
        />
      )}
    </>
  );
}
